import apiUrl from "../../../../constants";
import axios from "axios";
import Paginate from "vuejs-paginate";
import CryptoJS from "crypto-js";
import VueElementLoading from "vue-element-loading";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import download from 'downloadjs';
import utils from "../../../../utils/validateScanner"

export default {
  name: "ApprovalStatus",
  mixins: [utils],
  components: {
    VueElementLoading,
    Paginate,
    DatePicker,
    download
  },
  data() {
    return {
      isLoading: false,
      shipmentList: [],
      hubid: [],
      checkedType: "overage",
      shippingID: "",
      shippingIDError: "",
      checkedTypeError: "",
      FromDate: moment().subtract(30, 'days').format('YYYY-MM-DD HH:mm:ss'),
      todate: moment().format('YYYY-MM-DD HH:mm:ss'),
      todaysDate: new Date(),
      status: '',
      token: "",
      userData: [],
      currentPage: 1,
      pageCount: 0,
			pageNo: 0,
      shipmentListexport: [],
			limit: 20,
			totalRows: 0
    };
  },
computed: {},
  filters: {
    moment: function(date) {
          if (date == null || date == '')
            return '--'
          return moment(date).format('DD-MM-YYYY');
        }
  },
  mounted() {
    const userTokenEncrypt = window.localStorage.getItem("userToken");
    const userTokenDecrypt = CryptoJS.AES.decrypt(userTokenEncrypt.toString(), "Key");
    const userToken = userTokenDecrypt.toString(CryptoJS.enc.Utf8);
    this.token = JSON.parse(userToken);

    const userdetailEncrypt = window.localStorage.getItem("userdetail");
    const bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), "Key");
    const plaintext = bytes.toString(CryptoJS.enc.Utf8);
    const userdetail = JSON.parse(plaintext);
    this.userData = userdetail;
    this.hubid = userdetail[0].HubId[0];
    this.showOverageDetails();
  },
  methods: {
    clearError() {
      this.shippingIDError = this.shippingID ? "" : "The shipping ID field is required.";
    },
    showShipppingIdDetails(shippingId) {
      this.checkedTypeError = "";
      this.shippingIDError = shippingID ? "" : "The shipping ID field is required.";
      this.shipmentList =[];
      this.isLoading = true;
      
      this.input = {
        type: this.checkedType,
        hubId: this.hubid,
        pageIndex: this.pageNo,
        pageSize: this.limit,
        ToDate: this.todate || null,
        FromDate: this.FromDate || null,
        approvalStatus : this.status || null,
        shippingId:shippingId
      };
      axios.post(apiUrl.api_url_hubops + "approvalStatusList", this.input, {
        headers: {
          authorization: "authkey xB84JJ89Hd25",
        },
      })
      .then((response) => {
        this.isLoading = false;
        if (response.data.ResultCode == 100) {
          this.shipmentList = response.data.ResponseData || []; 
          this.totalRows = response.data.TotalCount;
          if(Object.keys(response.data.lossCategorization).length !=0){
							this.colorCode = response.data.lossCategorization.colorCode;
              this.colorIcon = response.data.lossCategorization.icon;
          }
        } else {
          this.shipmentList = [];
          this.showHideCodeIconInput();
          this.$alertify.error(response.data.ReturnMessage);
        }
      })
      .catch((httpException) => {
        this.isLoading = false;
        this.showHideCodeIconInput();
        console.error("exception is:::::::::", httpException);
      });
    },
    showOverageDetails() {
      this.checkedTypeError = "";
      this.shippingID = "";
      this.shippingIDError ="";
      this.shipmentList =[];
      this.isLoading = true;
      this.totalRows = 0;
      this.input = {
        type: this.checkedType,
        hubId: this.hubid,
        pageIndex: this.pageNo,
        pageSize: this.limit,
        ToDate: this.todate || null,
        FromDate: this.FromDate || null,
        approvalStatus : this.status || null
      };
      axios.post(apiUrl.api_url_hubops + "approvalStatusList", this.input, {
        headers: {
          authorization: "authkey xB84JJ89Hd25",
        },
      })
      .then((response) => {
        this.isLoading = false;
        if (response.data.ResultCode == 100) {
          this.shipmentList = response.data.ResponseData || []; 
          this.totalRows = response.data.TotalCount;
          if (this.totalRows < this.limit) {
            this.pageCount = 1
          } else {
            this.pageCount = Math.ceil(this.totalRows / this.limit);
          }
        } else {
          this.shipmentList = [];
          this.totalRows = 0;
          this.$alertify.error(response.data.ReturnMessage);
        }
      })
      .catch((httpException) => {
        this.isLoading = false;
        console.error("exception is:::::::::", httpException);
      });
    },
    getPaginationData(pageNum) {
			this.pageNo = (pageNum - 1);
      this.currentPage = pageNum;
			this.showOverageDetails()
		},
    clearID() {
      this.shippingID = "";
      this.shippingIDError = "";
      this.shipmentList = [];
      this.FromDate= '';
      this.todate= '';
      this.isLoading = false;
      this.pageNo= 0,
      this.status ="";
      this.totalRows=0;
      this.currentPage = 1;
      this.shipmentListexport = [];
      this.checkedTypeError = this.checkedType ? "" : "Select Type";
      this.$validator.reset();
    },

    resetForm() {
      this.checkedType = "overage";
      this.checkedTypeError = "";
      this.shipmentList = [];
      this.isLoading = false;
      this.$validator.reset();
      this.FromDate= '';
      this.todate= '';
      this.pageNo= 0,
      this.status ="";
      this.totalRows=0;
      this.currentPage = 1;
      this.shipmentListexport =[];
      this.shippingID = "";
      this.shippingIDError = "";
      this.$validator.reset();
      this.showHideCodeIconInput();
    },

    exportList() {
      this.checkedTypeError = "";
      this.shipmentListexport =[];
      this.isLoading = true;
      this.input = {
        type: this.checkedType,
        hubId: this.hubid,
        ToDate: this.todate || null,
        FromDate: this.FromDate || null,
        approvalStatus : this.status || null
      };
      axios.post(apiUrl.api_url_hubops + "approvalStatusList", this.input, {
        headers: {
          authorization: "authkey xB84JJ89Hd25",
        },
      })
      .then((response) => {
        this.isLoading = false;
        if (response.data.ResultCode == 100) {
          this.shipmentListexport = response.data.ResponseData || []; 
          this.getCSVFile();
        } else {
          this.shipmentListexport = [];
          this.$alertify.error(response.data.ReturnMessage);
        }
      })
      .catch((httpException) => {
        this.isLoading = false;
        console.error("exception is:::::::::", httpException);
      });
    },

    jsonToCSV(filename, data, csvfield, dateFilder = [], skipFilter = []) {
         var csvData = ''
         //Header
         if (this.title != null) {
           csvData += this.parseExtraData(this.title, '${data}\r\n')
         }
         //Fields
         for (let key in data[0]) {
           if (skipFilter.indexOf(key) == -1)
             csvData += csvfield[key] + ','
         }
         csvData = csvData.slice(0, csvData.length - 1)
         csvData += '\r\n'
         //Data
         data.map(function(item) {
           for (let key in item) {
             if (skipFilter.indexOf(key) == -1) {
               var escapedCSV = item[key] + '' // cast Numbers to string
               if (escapedCSV.match(/[,"\n]/)) {
                 escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"'
               }
               if (escapedCSV == 'null')
                 csvData += ',';
               else {
                 if (dateFilder.indexOf(key) != -1)
                   csvData += moment(escapedCSV).format('DD-MM-YYYY HH:mm:ss') + ','
                 else
                   csvData += escapedCSV + ','
               }
             }
           }
           csvData = csvData.slice(0, csvData.length - 1)
           csvData += '\r\n'
         })
         //Footer
         if (this.footer != null) {
           csvData += this.parseExtraData(this.footer, '${data}\r\n')
         }
         filename += moment().format('DD-MM-YYYY') + '.csv';
         return this.export(csvData, filename, "application/csv");
         return csvData
       },
    
        export (data, filename, mime) {
         let blob = this.base64ToBlob(data, mime)
         download(blob, filename, mime)
       },
    
        base64ToBlob(data, mime) {
         let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
         let bstr = atob(base64)
         let n = bstr.length
         let u8arr = new Uint8ClampedArray(n)
         while (n--) {
           u8arr[n] = bstr.charCodeAt(n)
         }
         return new Blob([u8arr], {
           type: mime
         })
       },


        getCSVFile(){
        this.csvData=[]
        this.shipmentListexport.map(item=>{
          this.csvData.push({
            ShipmentId: item.shippingid,
            Type:this.checkedType,
            Status:item.approvalstatus,
            ApprovalRequested: item.approvalrequesteddate,
            Remarks: item.remarks
          })
        })
  
        this.csvFields = {
          'ShipmentId': 'ShipmentId',
          'Type': 'Type',
          'Status': 'Status',
          'ApprovalRequested': 'ApprovalRequested',
          'Remarks': 'Remarks'
        }
        this.jsonToCSV('ApprovalStatusData', this.csvData, this.csvFields);
      },
  },
};



// WEBPACK FOOTER //
// ./src/views/components/InscanOverageShortage/ApprovalStatus/ApprovalStatus.js